import { coreClient } from '@/api/coreclient'

export default {
  async index() {
    const client = await coreClient()
    return client.task
      .index()
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return []
      })
  },
  async show(id: number) {
    const client = await coreClient()
    return client.task
      .show(id)
      .then((data) => {
        return data.data
      })
      .catch((e) => {
        console.error(e)
        return null
      })
  }
}
